import { lazy } from 'react';

import { useModal } from '../modal';

import type { ConfirmationModalProps } from './ConfirmationModal';

const Component = lazy(() => import('./ConfirmationModal'));

export const useConfirmationModal = () => {
  const { showModal } = useModal(Component);

  return {
    confirm: (props: Omit<ConfirmationModalProps, 'confirm'>) =>
      new Promise<boolean>((resolve) => {
        showModal({
          ...props,
          confirm: resolve,
        });
      }),
  };
};
